import { format } from 'date-fns';

type ReturnValue = string | undefined;
/**
 * Formats a date in correct timezone.
 * @param date
 */
export function formatDate(
	date: Date | undefined,
	template: string,
): ReturnValue {
	if (date) {
		return format(date, template);
	}
	return undefined;
}
